import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../contexts/auth.context";

const Protected = () => {
  const location = useLocation();
  const { pathname, search } = location;

  const { user, loading } = useAuth();

  if (loading) {
    // show loading spinner while checking auth
    return (
      <div className='w-full h-screen flex justify-center items-center'>
        <div className="h-12 w-12 border-[4px] border-[#4F46E5] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        replace={true}
        state={{ redirectedFrom: pathname, search }}
      />
    );
  }

  return <Outlet />;
};

export default Protected;
